var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sort clearfix"},[_c('li',{class:{ active: _vm.sort == 0 },on:{"click":function($event){return _vm.changeSort(0)}}},[_vm._v("综合")]),_c('li',{class:{ active: _vm.sort == 1 },on:{"click":function($event){return _vm.changeSort(1)}}},[_vm._v("最新")]),_c('li',{class:{ active: _vm.sort == 2 },on:{"click":function($event){return _vm.changeSort(2)}}},[_vm._v("最热")]),(!_vm.isOpen)?_c('li',{staticClass:"sort-price",class:{
      active: _vm.sort == 3 || _vm.sort == 4,
      desc: _vm.sort == '4',
      asc: _vm.sort == '3',
    },on:{"click":function($event){return _vm.changeSort(_vm.sort == 3 ? 4 : 3)}}},[_vm._v("\n    价格\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }